export function breakStringWithNewLines(input: string, maxLineLength: number, breakWords = false) {
  const spaceBetweenWords = breakWords ? '' : ' ';
  const words = input.split(spaceBetweenWords);
  let currentLine = '';

  const linesUsingReduce = words.reduce<string[]>((stringAccumulator, word) => {
    if (currentLine.length + word.length <= maxLineLength) {
      currentLine += spaceBetweenWords + word;
    } else {
      stringAccumulator.push(currentLine);
      currentLine = word;
    }

    return stringAccumulator;
  }, []);

  linesUsingReduce.push(currentLine);

  return linesUsingReduce.join('\n');
}

export function sanitizeCsvString(input: string) {
  const sanitizedString = input.replace(/[^a-zA-Z0-9\s]/g, '');

  return sanitizedString.trim();
}

export function sliceLongString(value: string, maxLength: number): string {
  if (value.length <= maxLength) {
    return value;
  }

  return `${value.slice(0, maxLength)}...`;
}
